// ─────────────────────────────────────────────
// KLOTHIQ Admin Platform — Business Enums
// ─────────────────────────────────────────────
// All business status and type enumerations.
// These mirror the PostgreSQL enums in the database.

// ── User & Organization ──

export enum UserRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  STAFF = 'staff',
  VIEWER = 'viewer',
}

// ── Product ──

export enum ProductSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  XXXL = '3XL',
  FREE = 'Free Size',
}

// ── Purchase ──

export enum PurchaseStatus {
  DRAFT = 'draft',
  ORDERED = 'ordered',
  PARTIALLY_RECEIVED = 'partially_received',
  RECEIVED = 'received',
  CANCELLED = 'cancelled',
  RETURNED = 'returned',
}

// ── Sale ──

export enum SaleStatus {
  DRAFT = 'draft',
  BOOKED = 'booked',
  CONFIRMED = 'confirmed',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  PARTIALLY_RETURNED = 'partially_returned',
  RETURNED = 'returned',
}

// ── Payment ──

export enum PaymentStatus {
  UNPAID = 'unpaid',
  PARTIALLY_PAID = 'partially_paid',
  PAID = 'paid',
  PARTIALLY_REFUNDED = 'partially_refunded',
  REFUNDED = 'refunded',
}

export enum PaymentType {
  SALE_PAYMENT = 'sale_payment',
  PURCHASE_PAYMENT = 'purchase_payment',
  REFUND = 'refund',
  ADVANCE = 'advance',
}

export enum PaymentMethod {
  CASH = 'cash',
  BANK_TRANSFER = 'bank_transfer',
  UPI = 'upi',
  CHEQUE = 'cheque',
  OTHER = 'other',
}

// ── Stock ──

export enum MovementType {
  OPENING_STOCK = 'opening_stock',
  PURCHASE_RECEIPT = 'purchase_receipt',
  SALE_DELIVERY = 'sale_delivery',
  CUSTOMER_RETURN = 'customer_return',
  PURCHASE_RETURN = 'purchase_return',
  DAMAGED = 'damaged',
  ADJUSTMENT_IN = 'adjustment_in',
  ADJUSTMENT_OUT = 'adjustment_out',
  STOCK_COUNT = 'stock_count',
}

export enum ReservationStatus {
  ACTIVE = 'active',
  RELEASED = 'released',
  CONVERTED = 'converted',
  CANCELLED = 'cancelled',
}

// ── Cash ──

export enum CashAccountType {
  CASH = 'cash',
  BANK = 'bank',
  UPI = 'upi',
}

export enum CashTransactionType {
  CAPITAL_IN = 'capital_in',
  CAPITAL_OUT = 'capital_out',
  SALE_PAYMENT = 'sale_payment',
  PURCHASE_PAYMENT = 'purchase_payment',
  OTHER_INCOME = 'other_income',
  EXPENSE = 'expense',
  CUSTOMER_REFUND = 'customer_refund',
  SUPPLIER_REFUND = 'supplier_refund',
  TRANSFER_IN = 'transfer_in',
  TRANSFER_OUT = 'transfer_out',
  OPENING_BALANCE = 'opening_balance',
  ADJUSTMENT = 'adjustment',
}

export enum CashDirection {
  IN = 'in',
  OUT = 'out',
}

// ── Audit ──

export enum AuditAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  STATUS_CHANGE = 'status_change',
  VOID = 'void',
  RECEIVE = 'receive',
  DELIVER = 'deliver',
  PAYMENT = 'payment',
  REFUND = 'refund',
  RESERVE = 'reserve',
  RELEASE = 'release',
  ADJUST = 'adjust',
  LOGIN = 'login',
  LOGOUT = 'logout',
}

// ── Reference types for linking ──

export enum ReferenceType {
  PURCHASE = 'purchase',
  PURCHASE_ITEM = 'purchase_item',
  SALE = 'sale',
  SALE_ITEM = 'sale_item',
  SALE_RETURN = 'sale_return',
  PAYMENT = 'payment',
  TRANSFER = 'transfer',
  EXPENSE = 'expense',
  ADJUSTMENT = 'adjustment',
}

// ── Return condition ──

export enum ReturnCondition {
  GOOD = 'good',
  DAMAGED = 'damaged',
  DEFECTIVE = 'defective',
}

// ── Plans & Tasks ──

export enum PlanPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
}

export enum TaskStatus {
  TODO = 'todo',
  IN_PROGRESS = 'in_progress',
  BLOCKED = 'blocked',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}
